<template>
  <li class="goods-item">
    <div v-show="type === 'cart'" class="goods-check">
      <el-checkbox
        :value="itemData.isCheck"
        @change="checkChange($event, itemIndex)"
      ></el-checkbox>
    </div>
    <div class="goods-info">
      <div @click="goDetail" class="goods-cover">
        <el-image fit="contain" :src="itemData.cover">
          <div slot="error" class="image-slot">
            <el-image
              fit="cover"
              :src="require('@/assets/images/default_img.jpg')"
            ></el-image>
          </div>
        </el-image>
      </div>
      <div class="goods-name">
        <span @click="goDetail">{{
          itemData.goodsTitle || itemData.subjectTitle
        }}</span>
      </div>
    </div>

    <div class="goods-price ou-expand">
      <span v-if="type === 'cart'" class="price-span">{{
        itemData.realPrice | paymentText
      }}</span>
      <span
        class="price-span"
        :class="[type === 'cart' ? 'origin' : 'narmal']"
        >{{ itemData.prices | paymentText }}</span
      >
    </div>
    <div v-show="type === 'cart'" class="goods-action ou-expand">
      <el-button
        type="text"
        class="ou-btn-text"
        icon="el-icon-delete"
        @click="deleteItem($event, itemData.id, itemData.goodsId)"
        >移除</el-button
      >
    </div>
    <div v-show="type === 'preOrder'" class="goods-price ou-expand">
      <span class="price-span">{{ itemData.realPrice }}</span>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiDeleteCartItem, apiBatDeleteCartItems } from "@/api/cart/cart";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
export default {
  name: "CartItem",
  props: {
    type: { type: String, default: "preOrder" },
    itemIndex: { type: Number, default: -1 },
    itemData: { type: Object },
  },
  data() {
    return {
      visible: false,
    };
  },
  components: {},
  watch: {},
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    checkChange(val, key) {
      // 更新vuex中购物车商品是否勾选的状态
      console.log("勾选", val, key);
      this.updateShoppingCart({ key: key, prop: "isCheck", val: val });
    },
    deleteItem(e, id, goodsId) {
      this.$confirm(`确定要移除该商品吗？`, "系统提示", {
        type: "warning",
      }).then(() => {
        apiBatDeleteCartItems({ ids: id }).then((res) => {
          console.log("单条移除购物车商品返回", res);
          this.deleteShoppingCart(id);
          this.$message.success("移除成功");
        });
      });
    },
    goDetail() {
      if (this.itemData.isSubject) {
        this.$router.push({
          path: "/special/specialDetail",
          query: { subjectId: this.itemData.subjectId },
        });
      } else {
        goodsInfoDetail(this.itemData.goodsId)
          .then((res) => {
            let status =
              res.data && res.data.goods ? res.data.goods.status : -1;
            if (status === 5 || status === 6) {
              this.$message.error(
                status === 6 ? "该商品已紧急下架" : "该商品已下架"
              );
              return;
            }
            if (this.itemData.resourceType != "train") {
              this.$router.push({
                path: "/bookstore/bookstoreDetail",
                query: { goodsId: this.itemData.goodsId },
              });
            } else {
              this.$router.push({
                path: "/willingLearn/bookstoreDetail",
                query: { goodsId: this.itemData.goodsId },
              });
            }
          })
          .catch((err) => {
            this.$message.error("获取商品详情失败, 暂时无法浏览");
          });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
